export const DIVIDER = " // ";
